import { ColumnDef } from '@tanstack/react-table'
import { GetReturnLossHistoryResponseData } from '@/modules/promotion/type'
import { format } from 'date-fns'
import { Badge } from '@/common/ui/badge'

export const columns: ColumnDef<GetReturnLossHistoryResponseData>[] = [
	{
		accessorKey: 'playerPhone',
		header: 'ผู้เล่น/โปรโมชัน',
		cell: ({ row }) => (
			<div className="space-y-1">
				<p>{row.original.playerPhone || '-'}</p>
				<p className="text-xs text-muted-foreground">
					โปรโมชัน: {row.original.returnLossName || '-'}
				</p>
			</div>
		),
	},
	{
		accessorKey: 'amount',
		header: 'เครดิต/ยอดเสีย',
		cell: ({ row }) => (
			<div className="space-y-1 text-left text-sm">
				<p>เครดิต: {row.original.amount.toLocaleString()}</p>
				<p className="text-muted-foreground">
					ยอดเสียรวม: {row.original.totalLossAmount.toLocaleString()}
				</p>
			</div>
		),
	},
	{
		accessorKey: 'balanceBefore',
		header: 'ยอดก่อน/หลัง',
		cell: ({ row }) => (
			<div className="space-y-1 text-left text-sm">
				<p>ก่อน: {row.original.balanceBefore.toLocaleString()}</p>
				<p className="text-muted-foreground">
					หลัง: {row.original.balanceAfter.toLocaleString()}
				</p>
			</div>
		),
	},
	{
		accessorKey: 'status',
		header: 'สถานะ/การรับ',
		cell: ({ row }) => (
			<div className="space-y-1">
				<Badge
					variant={row.original.status === 'ACTIVE' ? 'default' : 'secondary'}
				>
					{row.original.status}
				</Badge>
				<Badge variant={row.original.isReceived ? 'default' : 'secondary'}>
					{row.original.isReceived ? 'รับแล้ว' : 'ยังไม่รับ'}
				</Badge>
			</div>
		),
	},
	{
		accessorKey: 'createdAt',
		header: 'เวลา',
		cell: ({ row }) => (
			<div className="space-y-1 text-xs">
				<p>
					สร้าง: {format(new Date(row.original.createdAt), 'dd/MM/yyyy HH:mm')}
				</p>
				<p className="text-muted-foreground">
					หมดอายุ:{' '}
					{format(new Date(row.original.expiredAt), 'dd/MM/yyyy HH:mm')}
				</p>
			</div>
		),
	},
]
